import 'es6-promise/auto';
import Vue from 'vue';
import * as svgicon from 'vue-svgicon';
import App from './App.vue';
import router from './router';
import store from './store/';
import '@/components/icons';
import Vuelidate from 'vuelidate';
import i18n from './i18n';
import infiniteScroll from 'vue-infinite-scroll';
import VueAgile from 'vue-agile';

Vue.config.productionTip = false;

Vue.use(svgicon, {
  classPrefix: 'Icon-'
});

Vue.use(Vuelidate);
Vue.use(infiniteScroll);
Vue.use(VueAgile);

new Vue({
  router,
  store,
  created() {
    const noContext = ['forbidden', 'not-found', 'logout'];

    if (!noContext.includes(window.location.pathname.replace('/', ''))) {
      store.dispatch('entities/context/init');
    }
  },
  i18n,
  render: h => h(App)
}).$mount('#app');
